import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import ReactMarkdown from 'react-markdown';

import { Grid, TextEnterExit, fontSize } from 'style';
import TextListItemService from './textListItem.service';

class TextListItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sticky: false,
      top: 0,
      boundary: 0,
      listItemIndex: 0,
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.scrollUp = this.scrollUp.bind(this);
  }
  scrollUp() {
    window.scroll({
      top: this.getTitlePosition(),
      left: 0,
      behavior: 'smooth',
    });
  }
  handleScroll() {
    const { sticky, boundary } = this.state;
    var y = window.scrollY + 2;

    if (y > boundary) {
      this.setState({ sticky: true });
    } else if (sticky === true) {
      this.setState({ sticky: false });
    }
  }

  handleResize() {
    this.setState(
      () => ({
        boundary: this.getTitlePosition(),
        top: this.getTitleHeightOffset(),
        sticky: false,
      }),
      () => this.handleScroll
    );
  }

  getTitlePosition() {
    return (
      this.titleWrapper.getBoundingClientRect().top -
      this.getTitleHeightOffset() +
      window.scrollY
    );
  }

  getTitleHeightOffset() {
    const offset =
      this.state.listItemIndex *
      this.title.getBoundingClientRect().height;
    return offset;
  }

  addEventListeners() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  }

  removeEventListeners() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  componentWillMount() {
    this.setState(() => ({
      listItemIndex: TextListItemService.getIndex(),
    }));
    TextListItemService.addToIndex();
  }

  componentDidMount() {
    this.addEventListeners();
    this.handleResize();
  }

  componentWillUnmount() {
    TextListItemService.resetIndex();
    this.removeEventListeners();
  }

  render() {
    const { sticky, top } = this.state;
    const { title, text } = this.props;
    return (
      <Grid.Container id="textListItemComponent">
        <TextListItemWrapper /*removed innerRef*/ ref={el => (this.wrapper = el)}>
          <TitleWrapper /*removed innerRef*/ ref={el => (this.titleWrapper = el)}>
            <Title
                            /*removed innerRef*/ ref={el => (this.title = el)}
              data-cursor="focus"
              data-cursor-persistance="200"
              data-cursor-props={JSON.stringify({
                text: '\u2191',
              })}
              {...{
                sticky,
                top,
              }}
              onClick={this.scrollUp.bind(this)}>
              {title}
            </Title>
          </TitleWrapper>
          <Text>
            <ReactMarkdown
              source={text}
              containerTagName="div"
              className="markdown"
              renderers={{ root: 'div' }}
            />
          </Text>
        </TextListItemWrapper>
      </Grid.Container>
    );
  }
}

const TextListItemWrapper = styled.div`
    padding-bottom: 100px;
    display: flex;
`;

const TitleWrapper = styled.div`
    flex: 1 1 auto;
    min-width: 40%;
`;

const Title = styled.div`
    font-size: ${fontSize(50)};
    top: ${props => props.top}px;
    position: ${props => (props.sticky ? 'fixed' : 'initial')};
    ${TextEnterExit};
`;

const Text = styled.div`
    ${TextEnterExit};
`;

export default TextListItem;
